import Model from "../../utils/RestModel.js";
import Field from "../../utils/Field.js";
import CalculatedPenaltyInterestPeriod from "./CalculatedPenaltyInterestPeriod";

export default new Model(function () {
    this.totalInterest = new Field().asMoney().asReadOnly();
    this.periods = new Field([CalculatedPenaltyInterestPeriod]).asReadOnly();
}, "Calculated penalty interest");
